'use client';

import { useRef } from 'react';
import { Provider } from 'react-redux';

import { setUser } from '@/store/reducers/auth-reducer';
import { AppStore, makeStore } from '@/store/store';
import { getUserFomStorage } from '@/utilities/storage';

const StoreProvider: React.FC<ComponentWithChildren> = ({ children }) => {
  const storeRef = useRef<AppStore>();
  if (!storeRef.current) {
    storeRef.current = makeStore();
    const user = getUserFomStorage();
    if (user) {
      storeRef.current.dispatch(setUser(user));
    }
  }

  return <Provider store={storeRef.current}>{children}</Provider>;
};

export default StoreProvider;
